import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 15238 21829"
    {...props}
  >
    <path
      d="M4036 9925c656-790 1376-1371 2152-1749 775-383 1645-572 2604-572 919 0 1774 174 2555 517 780 343 1466 835 2052 1471 587 636 1039 1387 1357 2247 323 865 482 1769 482 2708 0 1372-313 2615-939 3728-626 1118-1496 1988-2619 2614-1119 626-2391 940-3808 940-1630 0-3036-398-4219-1193s-2088-1973-2714-3529S0 13643 0 11396c0-1833 189-3474 567-4920 377-1446 924-2644 1630-3593 710-954 1570-1670 2579-2157C5785 244 6933 0 8226 0c1242 0 2335 244 3280 726 949 487 1660 1088 2142 1804 477 715 720 1406 720 2063 0 397-154 760-452 1083s-681 487-1148 487c-408 0-785-129-1133-388-348-253-607-611-771-1068-223-582-576-1049-1063-1402-482-353-1049-532-1690-532-512 0-1024 150-1536 443-507 298-939 701-1287 1203-711 1028-1128 2867-1252 5506zm3931 9041c979 0 1794-403 2435-1203s959-1849 959-3151c0-880-149-1640-452-2276-298-637-710-1124-1237-1457s-1104-501-1735-501c-601 0-1178 159-1724 482-552 318-990 780-1327 1386-333 607-502 1317-502 2132 0 1312 337 2406 1019 3276 680 874 1535 1312 2564 1312z"
      style={{
        fill: "#2b2a29",
        fillRule: "nonzero",
      }}
      className="fill"

    />
  </svg>
)
export default SvgComponent
